import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import storageService from '@/services/storage.service'
import cryptojsService from '@/services/cryptojs.service'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    getters: {
        isAuthenticated: (state) => (state.auth && state.auth.authorized ? state.auth.authorized : null),
        auth: (state) => state.auth,
        notifyForm: (state) => state.notifyForm,
    },
    mutations: {
        authorized: (state, data) => {
            console.log('Mutation')
            console.log(data.payload.refresh_expires_in)
            Vue.set(state, 'auth', {
                authorized: true,
                dateTime: new Date().toISOString(),
                user: data.user,
                expires: {
                    expires_in: data.payload.expires_in,
                    refresh_expires_in: data.payload.refresh_expires_in,
                },
            })
        },
        notifyForm: (state, bolean) => {
            Vue.set(state, 'notifyForm', bolean)
        },
    },
    actions: {},
    plugins: [
        createPersistedState({
            setState(key, value) {
                storageService.set(key, cryptojsService.encrypted(value, true))
            },
            getState(key) {
                if (localStorage.getItem(key)) {
                    return JSON.parse(cryptojsService.decrypt(localStorage.getItem(key)))
                }
            },
        }),
    ],
})
